@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="container">
  <div class="row">
    <div class="span9">
      <h1> Register reports</h1>
    </div>
    <p class="lead">
      Send a registration message for each selected metadata reports.
      VENs must be 2.0b and have already created a registration with the VTN to perform this action.
    </p>
  </div>
  @if(isLoading) {
    <app-loader
      message="Loading...">
    </app-loader>
  } @else {
    <form name="requestForm" class="form-horizontal">
      <div class="form-group">
        <label for="venId"> Ven id (format: [name] : [id]): </label>
        <select id="venId" class="form-control" name="ven.ven_id" type="select" (change)="setVens($event.target)" required >
          <option disabled selected value></option>
          @for(ven of vens; track ven) {
            <option [value]="ven.id">{{ven.name}} : {{ven.id}}{{ven.paused ? " : (PAUSED)" : null}}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="metadata_report_ids"> Metadata reports (defaults to using all if none selected): </label>
        <select id="metadata_report_ids" class="form-control" name="metadata_report.metadata_report_ids" (change)="metadata($event.target)" type="select" multiple required >
          <option disabled selected value></option>
          @for(metadata_report of metadata_reports; track metadata_report) {
            <option [value]="metadata_report.id">{{metadata_report.report_specifier_id}} : {{metadata_report.label}}</option>
          }
        </select>
      </div>

      <button id="performAction" class="btn btn-primary" type="button" (click)="performAction()" [disabled]="!venSelected">Perform action</button>
    </form>

    <h5> Request Results</h5>
    <blockquote class="blockquote">
      <p class="mb-0">{{result}}</p>
    </blockquote>
  }

</div>
